import React, { useState, useEffect } from 'react';
import { Button, ButtonGroup, Card, CardBody, Row, Col, Label, Input } from 'reactstrap';
import ErrorBoundary from "components/ErrorBoundary";
import { dateFormate, cellRendererCheck, currencyFormat } from "utils/columns";
import useAxios from 'hooks/useAxios';
import { onExport, getUpdatedFilter } from 'utils/helper';
import ClaimDetailsTable from './ClaimDetailsTable';
import { cloneDeep, set } from 'lodash';
import useContextService from 'hooks/useContextService';

let initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: '',
  order: '',
  filters: [],
};

let thirdPartyAdminDetails = {};


const ClaimsDrawer = ({ tenantID, rowData }) => {
  const [columnFilters, setColumnFilters] = useState(null);
    const [colFilter, setColFilter] = useState([]);
  
  const {
    states: { purchaseOrder },
    setStates,
  } = useContextService();
  const { search, thirdPartyAdmin, coveredEntity, searchTerms } = purchaseOrder;



  const API = useAxios();
  const [state, updateState] = useState({
    data: [],
    loading: false,
    records: 0,
    reset: false,
  });
  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));



  useEffect(() => {
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: '',
      order: '',
      filters: [],
    };
    setColumnFilters(null);
    setState({ data: [], records: 0 });
    if (rowData) {
      initialFilters.currentPage = 1;
      fetchPOOrderDetails(initialFilters);
    }

  }, []);

  const fetchPOOrderDetails = async (pageDetails = {}, hasColumnFilter) => {
    setState({ loading: true });
    let filter = { ...pageDetails };
    if (hasColumnFilter) {
      filter.filters = [...initialFilters.filters, ...pageDetails.filters];
      //initialFilters.filters = [...filter.filters];
    } else {
      initialFilters = { ...initialFilters, ...filter };
    }
    setColumnFilters(filter);
    try {
      const { data } = await API.post(
        `/${tenantID}/PurchaseOrder/ClaimDetails/${rowData.contractID}/${rowData.poid}`, filter
      );
      if (data) {
        console.log(data.items);
        setState({
          data: data.items,
          records: data.totalRecords,
          loading: false,
        });
      } else {
        setState({
          data: [],
          records: 0,
          loading: false,
        });
      }
    } catch (error) {
      setState({ loading: false, data: [], records: 0 });
    }
  };

  const handleExportPoClaims = async () => {
    const filterObj = cloneDeep(search); 
    const defaulfFilterNames = new Set((search.filters||[]).map(f => f.filterName));
    filterObj.filters = (filterObj.filters = (filterObj.filters || []).filter(f =>  !defaulfFilterNames.has(f.filterName)));

    if (initialFilters.filters.length > 0 || colFilter || colFilter.length > 0) {
      filterObj.filters = [...(filterObj.filters || []),
      ...(colFilter.filters || []),
      ...(initialFilters.filters || [])];
    }

    filterObj.orderBy = "";
    filterObj.order = "";
    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    // filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID || 0;
    additionalCriteria.contractID = rowData.contractID || 0;
    filterObj.poid = rowData.poid || 0;
    var payload = {};
    payload.tenantID = tenantID;
    payload.gridCode = "POClaims";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };

  const onPageChange = (filter, hasFilter) => {
    if (hasFilter) {
      fetchPOOrderDetails(filter, true);
    } else {
      fetchPOOrderDetails(filter);
    }
  };

  const handleSearchColumnFilters = async (columnFilters) => {
   setColFilter(columnFilters);
    await fetchPOOrderDetails({ ...initialFilters, ...columnFilters }, true);
  };

  const refetch = (hasReset) => {
    if (hasReset) {
      initialFilters = {
        ...initialFilters,
        currentPage: 1,
      };
      setColumnFilters(null);
    }
    fetchPOOrderDetails(initialFilters);
  };

  return (
    <Card>
      <CardBody>
        <Col xs="auto">
          <Row>
            <Col md='2'>
              <p className="m-0 f-14 float-end">PO# :</p>
            </Col>
            <Col md="2">
              <p className="m-0 f-14 font-weight-500">{rowData?.poid || ''}</p>
            </Col>

            <Col>
              <p className="m-0 f-14 float-end">PO Date :</p>
            </Col>
            <Col md="2">
              <p className="m-0 f-14 font-weight-500">{dateFormate(rowData?.poDate) || ''}</p>
            </Col>

            <Col>
              <p className="m-0 f-14 float-end">PO Status :</p>
            </Col>
            <Col md="2">
              <p className="m-0 f-14 font-weight-500">{rowData?.poStatus || ''}</p>
            </Col>
          </Row>
          <Row className='mt-4'>
            <Col md="2">
              <p className="m-0 f-14 float-end">Covered Entity :</p>
            </Col>
            <Col md="2">
              <p className="m-0 f-14 font-weight-500">{rowData?.coveredEntityName || ''}</p>
            </Col>
            <Col>
              <p className="m-0 f-14 float-end">Pharmacy :</p>
            </Col>
            <Col md="2">
              <p className="m-0 f-14 font-weight-500">{rowData?.pharmacyName || ''}</p>
            </Col>
            <Col md={2}>
              <p className="m-0 f-14 float-end">Wholesaler :</p>
            </Col>
            <Col md="2">
              <p className="m-0 f-14 font-weight-500">{rowData?.wholesaler || ''}</p>
            </Col>
          </Row>
        </Col>
      </CardBody>
      <CardBody className="border-top">
        <ErrorBoundary>
          <ClaimDetailsTable
            data={state.data}
            loading={state.loading}
            onExport={handleExportPoClaims}
            filters={initialFilters}
            totalSize={state.records}
            onPageChange={onPageChange}
            setLoading={(value) => setState({ loading: value })}
            refetch={refetch}
            onSearchColumnFilters={handleSearchColumnFilters}
            reset={state.reset}
          />
        </ErrorBoundary>

      </CardBody>

    </Card>
  );
};

export default ClaimsDrawer;
